export default "__VITE_ASSET__v_z8JLvP__"